// extracted by mini-css-extract-plugin
module.exports = {"profile":"UserProfile--profile--xiP5B","profile_container":"UserProfile--profile_container--3PPws","image_wrapper":"UserProfile--image_wrapper--2UIXE"};